import React, { useState, useEffect } from "react";

import { func_validation } from "functions";

import ic_small_add from "assets/images/ic_small_add.svg";
import ic_small_save from "assets/images/ic_small_save.svg";
import { Toaster } from "components/notification/Toaster";

export function useSubmission(props) {
    const {
        isEditing, isCloning,

        isEveryInputValid, isAnyInputChanged,

        companyDetails, productDetails,
        chargeDetails, miscellaneousDetails,
        sideDetails,

        isFormSubmissionAttempted,

        advancePaySetup: advancePaySetup_original,

        isAccountRecordUpdatedSuccessfully
    } = props;

    // Submits
    let submitIcon = isEditing? ic_small_save: ic_small_add;
    let submitText = isEditing? "Save": "Add";
    let submitAltText = isEditing? "Save Icon": "Add Icon";
    function handleSubmission() {
        let advancePaySetupId = func_validation.getObjectPropertyValue(advancePaySetup_original, "Id");

        if (isAnyInputChanged || isCloning) {
            if ((!isEditing || 
                (isEditing && func_validation.isNumberValid(advancePaySetupId))) &&
                isEveryInputValid) {

                let advancePaySetupId_validated = (func_validation.isNumberValid(advancePaySetupId) && isEditing)? advancePaySetupId:0;

                let advancePaySetup = func_validation.combineObjects([
                    { Id: advancePaySetupId_validated },
                    companyDetails, productDetails, 
                    chargeDetails, miscellaneousDetails, 
                    sideDetails
                ]);
                
                if (isEditing && props.updateAccount) 
                    props.updateAccount(advancePaySetup);
                else if (props.addAccount) 
                    props.addAccount(advancePaySetup);
            }
        }
        else {
            Toaster({
                type: "info",
                msg: "No input changed"
            })
        }
        
        if (func_validation.isFunction(props.setFormSubmissionStatus))
            props.setFormSubmissionStatus(true);
    }
    function handleSuccessfulSubmission() {
        if (isAccountRecordUpdatedSuccessfully &&
            isFormSubmissionAttempted &&
            props.updateParentState_visiblity)
            props.updateParentState_visiblity(false);
    }
    useEffect(() => {
        handleSuccessfulSubmission();
    }, [isAccountRecordUpdatedSuccessfully]);

    return {
        submitIcon, submitText, submitAltText,
        isEveryInputValid, handleSubmission
    }
}